"use strict"

import http from "../helpers/axiosClient";

export const SendContact = async (form,callback) => {
    try {
        http.post("/Articles/Article/SendContact",form).then(callback)
    } catch (e) {
        console.log("SendContact errors", e)
    }
}
